import { Input } from '../Input';

interface Field {
  key: string;
  label: string;
  type: string;
  description?: string;
  required: boolean;
}
interface ConnectionFormFieldsProps {
  fields: Field[];
  formData: Record<string, string>;
  errors: Record<string, string>;
  onInputChange: (key: string, value: string) => void;
}

export const ConnectionFormFields = ({
  fields,
  formData,
  errors,
  onInputChange,
}: ConnectionFormFieldsProps) => {
  return (
    <div className="space-y-4">
      {fields.map((field) => {
        return (
          <Input
            key={field.key}
            id={field.key}
            label={field.label}
            type={field.type}
            value={formData[field.key] || ''}
            onChange={(e) => onInputChange(field.key, e.target.value)}
            placeholder={`Enter ${field.label}`}
            required={field.required}
            error={errors[field.key]}
            subText={field.description}
          />
        );
      })}
    </div>
  );
};
